import { useEffect, useState } from "react";
import { api } from "../api";
import { refreshBranding } from "./BrandMark";
import type { NotificationKind } from "./Portal";

export function BrandingSettings({ onMessage }: { onMessage: (message: string, kind?: NotificationKind) => void }) {
  const [logoVersion, setLogoVersion] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);
  const report = (error: Error) => onMessage(error.message, "error");
  useEffect(() => { api.branding().then((info) => setLogoVersion(info.logoVersion)).catch(report); }, []);
  async function upload(file: File) {
    setUploading(true);
    try { const info = await api.uploadLogo(file); setLogoVersion(info.logoVersion); refreshBranding(); onMessage("Logo updated across the platform."); }
    finally { setUploading(false); }
  }
  async function remove() {
    const info = await api.deleteLogo(); setLogoVersion(info.logoVersion); refreshBranding(); onMessage("Custom logo removed; the default mark is back.");
  }
  return <section className="management-panel branding-settings"><h2>Branding</h2><p>Upload a square logo to replace the default mark in the sidebar, login, and loading screens. The TALAHWA wordmark stays.</p>
    <div className="product-image-field">
      {logoVersion ? <img src={api.brandingLogoUrl(logoVersion)} alt="Current logo"/> : <span className="product-image-empty">Default mark</span>}
      <div className="row-actions">
        <label className="secondary-button image-upload-button">{uploading ? "Uploading…" : "Upload logo"}<input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" hidden disabled={uploading} onChange={(event) => { const file = event.target.files?.[0]; event.target.value = ""; if (file) upload(file).catch(report); }}/></label>
        {logoVersion && <button type="button" className="secondary-button danger-button" onClick={() => remove().catch(report)}>Remove logo</button>}
      </div>
    </div>
  </section>;
}
